import { Directive, OnDestroy, OnChanges, Input, inject, input, output } from '@angular/core';

import { DatatableComponent } from '../../components/datatable/components/datatable.component';
import { TableSort } from '../../components/datatable/types/sort.type';
import { SortDirection } from '../../components/datatable/types/sort-direction.type';
import { SortEvent } from '../../domain/data-table.domain';
import { TableStateBaseDirective } from './table-state-base.directive';

@Directive({
  selector: '[tdWbTableState]'

})
export class TableStateDirective extends TableStateBaseDirective implements OnChanges, OnDestroy {
  private datatableComponent: DatatableComponent;

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input('tdWbTableState')
  set tableId(value: string) {
    this.stateId = value;
  }

  readonly stateResetEnabled = input<boolean>(false);
  readonly stateResetChange = output<Array<TableSort>>();

  constructor() {
    const datatableComponent = inject(DatatableComponent, { host: true });

    super(datatableComponent.sort);

    this.datatableComponent = datatableComponent;
  }

  ngOnChanges(): void {
    this.datatableComponent.sorts.set(this.getSorts());
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  onSort(sort: SortEvent): void {
    let sorts = sort.sorts;
    if (this.stateResetEnabled() && sort.newValue === SortDirection.ASC && sort.prevValue === SortDirection.DESC) {
      sorts = this.getDefaultSorts();
      this.datatableComponent.sorts.set(sorts);
      this.stateResetChange.emit(sorts);
    }
    this.setSorts(sorts);
  }
}
